import React from "react";
import { Component } from "react";
import styles from "../AboutUs/About.module.css";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import Constants from "../../constants/Constants";
import Tab from "./teamTab";
import Button from "../../commomComponents/button";
import Mail from "../../commomComponents/mail";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  Box,
} from "@chakra-ui/react";
import ReactHtmlParser from "react-html-parser";
import getAboutDetails from "../../services/request/about";
import { IMAGE_URL, SITE_ID } from "../../services/apiConstants";
import BannerWithHeading from "../../commomComponents/bannerWithHeading";
import sortObj from "../../utils/sortingObject";
import Loader from "../../commomComponents/Loader";
import ReactPlayer from "react-player";
import SeoHelmet from "../../commomComponents/seoHelmet";

export default class About extends Component {
  constructor(props) {
    super(props);
    this.state = {
      who: [],
      why: [],
      risks: [],
      team: [],
      stands: [],
      banner: [],
      belief: [],
      isMobile: "",
      isLoading: true,
    };
  }
  componentWillMount = () => {
    document.title = "About Us";
    this.callAllApis();
  };
  callAllApis = () => {
    const AboutUs = getAboutDetails();

    AboutUs.then((data) => {
      this.setState({
        who: data.data.who[0],
        banner: data.data.banner[0],
        why: data.data.why[0],
        team: data.data.team,
        stands: data.data.stands,
        risks: data.data.risks[0],
        belief: data.data.beliefs,
        isLoading: false,
      });
    });
  };
  sortObject = (obj, sortBy) => {
    let sortedObj = obj.sort(
      (a, b) => parseFloat(a[sortBy]) - parseFloat(b[sortBy])
    );
    return sortedObj;
  };

  render() {
    const { who, why, stands, banner, risks, isLoading } = this.state;
    const standData = this.sortObject(stands, "id");

    function scrollToSection1(sectionId) {
      const element = document.getElementById(sectionId);

      if (element) {
        const headerHeight = 200;
        const offset =
          element.getBoundingClientRect().top + window.scrollY - headerHeight;

        window.scrollTo({
          top: offset,
          behavior: "smooth", // For smooth scrolling
        });
      }
    }
    let whoText = who.text;
    whoText = String(whoText);
    let modifiedText = whoText.replace(
      /\(AIFs\)(.*?)\./,
      "(AIFs) and advisory mandate for international clients."
    );
    console.log(this.isLoading, "lode");

    const productSchema = {
      "@context": "https://schema.org",
      "@type": "Corporation",
      name: "ICICI Prudential Alternate Investments",
      url: "https://www.iciciprualternates.com/",
      logo: "https://www.iciciprualternates.com/static/media/logo.7de77484.svg",
      contactPoint: {
        "@type": "ContactPoint",
        telephone: "1800-268-0001",
        contactType: "customer service",
        areaServed: "IN",
        availableLanguage: "en",
      },
      sameAs: [
        "https://www.facebook.com/people/ICICI-Prudential-Alternate-Investments/61564527142001/",
        "https://x.com/ICICIAlternates",
        "https://www.instagram.com/iprualtinvestments/",
        "https://www.youtube.com/channel/UCx8zm0so0yzcIC3w2IdEndw",
        "https://www.linkedin.com/company/icici-prudential-amc-ltd",
      ],
    };
    return (
      <>
        <SeoHelmet
          title="About Us - ICICI Asset Management Company Limited"
          description="Get to know ICICI Pru Alternates, one of the best wealth management companies in India. We offer top-tier financial and investment management services."
          url="https://www.iciciprualternates.com/about-us"
          schemaJson={productSchema}
        />
        <div>
          {isLoading ? (
            <Loader />
          ) : (
            <>
              <Mail />
              <div>
                <div className={styles.imageBanner}>
                  {banner.image && (
                    <img src={IMAGE_URL + banner.image + SITE_ID} alt="" />
                  )}
                </div>
                {/* {banner.image && (
                <BannerWithHeading
                  bannerImage={IMAGE_URL + banner.image + SITE_ID}
                heading={banner.title}
                />
              )} */}

                <ul className={styles.buttonPills}>
                  <li>
                    <a
                      style={{ cursor: "pointer" }}
                      className={styles.btn}
                      onClick={() => scrollToSection1("who")}
                    >
                      Who Are We?
                    </a>
                  </li>

                  <li>
                    <a
                      style={{ cursor: "pointer" }}
                      className={styles.btn}
                      onClick={() => scrollToSection1("why")}
                    >
                      Why ICICI Prudential Asset Management Company?
                    </a>
                  </li>

                  {/* <li>
                <a href="#belief" className={styles.btn}>
                Core Belief
                </a>
              </li> */}

                  <li>
                    <a
                      style={{ cursor: "pointer" }}
                      className={styles.btn}
                      onClick={() => scrollToSection1("team")}
                    >
                      Our Team
                    </a>
                  </li>

                  <li>
                    <a
                      style={{ cursor: "pointer" }}
                      className={styles.btn}
                      onClick={() => scrollToSection1("what")}
                    >
                      What Do We Stand For?
                    </a>
                  </li>
                </ul>
              </div>
              <div className={styles.container} id="who">
                <p className={styles.heading}>{who.title}</p>
                <p
                  style={{ fontFamily: "Mulish, sans-serif !important" }}
                  className={styles.para}
                >
                  {ReactHtmlParser(modifiedText)}
                </p>

                <p className={styles.subpara}>{who.note}</p>
              </div>

              <div className={styles.section} id="why">
                <div className={styles.container}>
                  <p className={styles.heading}>{why.title}</p>

                  <div className={(styles.listsection, styles.list)}>
                    {ReactHtmlParser(why.text)}
                  </div>
                </div>
              </div>
              {/* 
            <div>
              <p style={{ color: "#97291E", fontSize: '26px', fontWeight: 500 }}>Our Stock Selection Process - Decoding Equity PMS & AIF</p>
            </div>
            <div>
              <div className={styles.videoContainer} >
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '365px', width: '700px', margin: '0 auto' }}> 
                <ReactPlayer
                  url={'https://www.youtube.com/watch?v=apn5IwpAIgw&t=9s'}
                  width="100%"
                  height="100%"
                  display="initial"
                  controls={true}
                />
              </div>


            </div>
            */}
              <div className={styles.section}>
                <div className={styles.milestone} id="team">
                  <div className={styles.container}>
                    <p className={styles.heading}>{Constants.team}</p>
                    <div>
                      <Tab />
                    </div>
                  </div>
                </div>

                <div className={styles.section} id="what">
                  <div className={styles.container}>
                    <p className={styles.heading}>{Constants.standFor}</p>

                    <Accordion allowToggle isfocusable={true}>
                      {standData.map((data) => {
                        return (
                          <AccordionItem>
                            {({ isExpanded }) => (
                              <>
                                <h2>
                                  <AccordionButton
                                    _expanded={{
                                      bg: "#97291e",
                                      color: "white",
                                    }}
                                    _hover={{ bg: "#97291e", color: "white" }}
                                    padding={20}
                                    fontSize={20}
                                    backgroundColor="white"
                                    color="#97291e"
                                    border="1px solid #97291e"
                                    fontFamily="Mulish, sans-serif"
                                  >
                                    <Box
                                      border={"transparent"}
                                      width={1300}
                                      textAlign="left"
                                      paddingLeft="3%"
                                      fontWeight={400}
                                    >
                                      {data.title}
                                    </Box>
                                    {isExpanded ? (
                                      <span className="crossPlus">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                        >
                                          <g
                                            fill="none"
                                            fill-rule="evenodd"
                                            opacity=".8"
                                          >
                                            <g>
                                              <path
                                                d="M0 0L24 0 24 24 0 24z"
                                                transform="translate(-1298 -5774) translate(1296 5772)"
                                              ></path>
                                              <path
                                                class="accord-arr"
                                                fill="white"
                                                fill-rule="nonzero"
                                                d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                                                transform="translate(-1298 -5774) translate(1296 5772)"
                                              ></path>
                                            </g>
                                          </g>
                                        </svg>
                                      </span>
                                    ) : (
                                      <span>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                        >
                                          <g
                                            fill="none"
                                            fill-rule="evenodd"
                                            opacity="1"
                                          >
                                            <g>
                                              <path
                                                d="M0 0L24 0 24 24 0 24z"
                                                transform="translate(-1298 -5774) translate(1296 5772)"
                                              ></path>
                                              <path
                                                class="accord-arr"
                                                fill="#c9b16d"
                                                fill-rule="nonzero"
                                                d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                                                transform="translate(-1298 -5774) translate(1296 5772)"
                                              ></path>
                                            </g>
                                          </g>
                                        </svg>
                                      </span>
                                    )}
                                  </AccordionButton>
                                </h2>
                                <AccordionPanel>
                                  <p className={styles.expandedContent}>
                                    {ReactHtmlParser(data.text)}
                                  </p>
                                </AccordionPanel>
                              </>
                            )}
                          </AccordionItem>
                        );
                      })}
                    </Accordion>
                    <div className={styles.riskCard}>
                      <div className={styles.riskCardTitle}>{risks.title}</div>
                      <p className={styles.riskcardContent}>
                        {ReactHtmlParser(risks.text)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </>
    );
  }
}
